import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/55_card_back_candy/55_card_back_candy"
 * Contains 1 texture(s)
 */
export class CardsBacks55CardBackCandyAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/55_card_back_candy/55_card_back_candy';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '55_candy.png'
    ] as const;
}
